
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authors/[alias]",
      function () {
        return require("private-next-pages/authors/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authors/[alias]"])
      });
    }
  